import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Box, Typography } from '@material-ui/core';

import { formatDate } from '../../utils/date';

import IconSuccess from '../../assets/icons/icon_success.svg';
import IconWarning from '../../assets/icons/icon_warning.svg';
import IconError from '../../assets/icons/icon_error.svg';

const assemblyStatusCardStyles = makeStyles({
  root: {
    backgroundColor: '#f3f3f3',
    borderRadius: '6px',
    borderLeft: '14px solid',
    borderLeftColor: ({ type }) => {
      if (type === 'success') {
        return '#58c22e';
      }

      if (type === 'warning') {
        return '#ffdc83';
      }

      return '#d12e2e';
    },
    '& .MuiCardContent-root': {
      padding: '24px 16px',
    },
    '& img': {
      width: '40px',
      height: '40px',
      marginRight: '16px',
    },
  },
  boxDate: {
    marginBottom: '16px',
  },
});

export default function AssemblyStatusCard(props) {
  const { type, updatedAt, reason, description } = props;
  const classes = assemblyStatusCardStyles(props);
  let icon;

  if (type === 'success') {
    icon = <img src={IconSuccess} alt="Ícone de sucesso" />;
  } else if (type === 'warning') {
    icon = <img src={IconWarning} alt="Ícone de alerta" />;
  } else {
    icon = <img src={IconError} alt="Ícone de erro" />;
  }

  const formattedUpdatedAtDate = useMemo(() => {
    return `Atualizado em ${formatDate(updatedAt, 'DD/MM')}`;
  }, [updatedAt]);

  return (
    <Card className={classes.root} elevation={0}>
      <CardContent>
        <Box className={classes.boxDate}>
          {updatedAt && (
            <Typography component="div">
              <Box fontSize={12}>{formattedUpdatedAtDate}</Box>
            </Typography>
          )}
        </Box>
        <Box display="flex" alignItems="center">
          <Box>{icon}</Box>
          <Box display="flex" flexDirection="column">
            <Typography component="div">
              <Box fontWeight="fontWeightBold" fontSize={14}>
                {reason}
              </Box>
              <Box fontSize={14}>{description}</Box>
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

AssemblyStatusCard.propTypes = {
  type: PropTypes.oneOf(['success', 'warning', 'error']).isRequired,
  updatedAt: PropTypes.string,
  reason: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

AssemblyStatusCard.defaultProps = {
  updatedAt: '',
};
